// @ts-nocheck
import { get, API_BASE_URL } from './utils/api/index';
/**
 * @typedef {Object} Veiculo
 * @property {string} frota - Nome da frota
 * @property {string} placa - Placa do veÃ­culo
 */
/**
 * @typedef {Object} Endereco
 * @property {string} logradouro - Logradouro
 * @property {string} numero - NÃºmero
 * @property {string} bairro - Bairro
 * @property {string} complemento - Complemento
 * @property {Object} cidade - Dados da cidade
 * @property {string} cidade.nome - Nome da cidade
 * @property {string} cidade.estado - Estado
 */
/**
 * @typedef {Object} Cliente
 * @property {string} cnpj - CNPJ do cliente
 * @property {string} nome - Nome do cliente
 * @property {string} sigla - Sigla do cliente
 */
/**
 * @typedef {Object} Previsibilidade
 * @property {number} kmRestante - QuilÃ´metros restantes
 * @property {number} progressoOrigem - Progresso da origem (0-100)
 * @property {number} progressoDestino - Progresso do destino (0-100)
 */
/**
 * @typedef {Object} PrevisaoCarga
 * @property {string} id - ID Ãºnico da viagem
 * @property {string} identificador - Identificador da viagem
 * @property {string} numeroCarga - NÃºmero da carga
 * @property {string} dataPrevisaoChegadaDestino - Data de previsÃ£o de chegada no destino
 * @property {Veiculo} veiculo - Dados do veÃ­culo
 * @property {Endereco} enderecoClienteOrigem - EndereÃ§o de origem
 * @property {Endereco} enderecoClienteDestino - EndereÃ§o de destino
 * @property {Cliente} clienteDestino - Cliente de destino
 * @property {Object} statusLogistico - Status logÃ­stico da viagem
 * @property {number} statusLogistico.id - ID do status
 * @property {string} statusLogistico.nome - Nome do status
 * @property {Previsibilidade} previsibilidade - Dados de previsibilidade
 */
/**
 * Busca cargas em trÃ¢nsito para o depÃ³sito
 * @param {Object} options - OpÃ§Ãµes de configuraÃ§Ã£o
 * @param {boolean} [options.useMock=false] - Se true, usa dados do mock ao invÃ©s da API
 * @returns {Promise<PrevisaoCarga[]>} Lista de cargas em trÃ¢nsito
 */
export const getCargasEmTransitoDeposito = async (options = {}) => {
    try {
        // const { useMock = false } = options;
        // console.log(`ðŸ” Buscando cargas em trÃ¢nsito para o depÃ³sito... (Modo: ${useMock ? 'MOCK' : 'API'})`);
        // ConstrÃ³i a URL com parÃ¢metros de query se necessÃ¡rio
        let url = `${API_BASE_URL}/previsao-cargas/cargas-em-transito-deposito`;
        // if (useMock) {
        //   console.log('ðŸ”§ Modo mock ativado - Adicionando parÃ¢metro useMock=true');
        //   url += '?useMock=true';
        // }
        console.log('ðŸŒ URL da requisiÃ§Ã£o:', url);
        const response = await get(url);
        // console.log(`ðŸ“¥ Resposta da API (${useMock ? 'MOCK' : 'API'}):`, response);
        const result = response?.data || response || [];
        // console.log(`ðŸ“¦ Resultado final (${useMock ? 'MOCK' : 'API'}):`, result.length, 'registros');
        return result;
    }
    catch (error) {
        console.error(`âŒ Erro ao buscar cargas em trÃ¢nsito:`, error);
        throw error;
    }
};
/**
 * Formata endereÃ§o para exibiÃ§Ã£o
 * @param {Endereco} addressObj - Objeto de endereÃ§o
 * @returns {Object} Objeto com main (cidade-estado) e subtitle (endereÃ§o completo)
 */
export const formatAddressParts = (addressObj) => {
    if (!addressObj || typeof addressObj !== 'object') {
        return { main: '', subtitle: '' };
    }
    const logradouro = addressObj.logradouro || '';
    const numero = addressObj.numero || '';
    const bairro = addressObj.bairro || '';
    const complemento = addressObj.complemento || '';
    const subtitleParts = [];
    if (logradouro)
        subtitleParts.push(logradouro);
    if (numero && (numero.toLowerCase() !== 's/n' || !logradouro))
        subtitleParts.push(numero);
    if (bairro)
        subtitleParts.push(bairro);
    if (complemento)
        subtitleParts.push(complemento);
    const subtitle = subtitleParts.filter(part => part).join(', ');
    let mainLocation = '';
    if (addressObj.cidade && typeof addressObj.cidade === 'object') {
        const cityName = addressObj.cidade.nome || '';
        const stateAbbr = addressObj.cidade.estado || '';
        if (cityName && stateAbbr)
            mainLocation = `${cityName} - ${stateAbbr}`;
        else if (cityName)
            mainLocation = cityName;
        else if (stateAbbr)
            mainLocation = stateAbbr;
    }
    return { main: mainLocation, subtitle: subtitle };
};
/**
 * Formata dados de origem incluindo razÃ£o social do cliente
 * @param {Endereco} addressObj - Objeto de endereÃ§o
 * @param {Cliente} clienteObj - Objeto do cliente
 * @returns {Object} Objeto com main (cidade-estado), subtitle (endereÃ§o) e cliente (razÃ£o social)
 */
export const formatOrigemParts = (addressObj, clienteObj) => {
    if (!addressObj || typeof addressObj !== 'object') {
        return { main: '', subtitle: '', cliente: '' };
    }
    const logradouro = addressObj.logradouro || '';
    const numero = addressObj.numero || '';
    const bairro = addressObj.bairro || '';
    const complemento = addressObj.complemento || '';
    const subtitleParts = [];
    if (logradouro)
        subtitleParts.push(logradouro);
    if (numero && (numero.toLowerCase() !== 's/n' || !logradouro))
        subtitleParts.push(numero);
    if (bairro)
        subtitleParts.push(bairro);
    if (complemento)
        subtitleParts.push(complemento);
    const subtitle = subtitleParts.filter(part => part).join(', ');
    let mainLocation = '';
    if (addressObj.cidade && typeof addressObj.cidade === 'object') {
        const cityName = addressObj.cidade.nome || '';
        const stateAbbr = addressObj.cidade.estado || '';
        if (cityName && stateAbbr)
            mainLocation = `${cityName} - ${stateAbbr}`;
        else if (cityName)
            mainLocation = cityName;
        else if (stateAbbr)
            mainLocation = stateAbbr;
    }
    // RazÃ£o social do cliente em campo separado
    const cliente = clienteObj && clienteObj.razaoSocial ? clienteObj.razaoSocial : '';
    return { main: mainLocation, subtitle: subtitle, cliente: cliente };
};
/**
 * Formata dados de destino incluindo razÃ£o social do cliente
 * @param {Endereco} addressObj - Objeto de endereÃ§o
 * @param {Cliente} clienteObj - Objeto do cliente
 * @returns {Object} Objeto com main (cidade-estado), subtitle (endereÃ§o) e cliente (razÃ£o social)
 */
export const formatDestinoParts = (addressObj, clienteObj) => {
    if (!addressObj || typeof addressObj !== 'object') {
        return { main: '', subtitle: '', cliente: '' };
    }
    const logradouro = addressObj.logradouro || '';
    const numero = addressObj.numero || '';
    const bairro = addressObj.bairro || '';
    const complemento = addressObj.complemento || '';
    const subtitleParts = [];
    if (logradouro)
        subtitleParts.push(logradouro);
    if (numero && (numero.toLowerCase() !== 's/n' || !logradouro))
        subtitleParts.push(numero);
    if (bairro)
        subtitleParts.push(bairro);
    if (complemento)
        subtitleParts.push(complemento);
    const subtitle = subtitleParts.filter(part => part).join(', ');
    let mainLocation = '';
    if (addressObj.cidade && typeof addressObj.cidade === 'object') {
        const cityName = addressObj.cidade.nome || '';
        const stateAbbr = addressObj.cidade.estado || '';
        if (cityName && stateAbbr)
            mainLocation = `${cityName} - ${stateAbbr}`;
        else if (cityName)
            mainLocation = cityName;
        else if (stateAbbr)
            mainLocation = stateAbbr;
    }
    // RazÃ£o social do cliente em campo separado
    const cliente = clienteObj && clienteObj.razaoSocial ? clienteObj.razaoSocial : '';
    return { main: mainLocation, subtitle: subtitle, cliente: cliente };
};
/**
 * Formata data, tempo restante e quilÃ´metros restantes
 * @param {string} previsaoDateString - Data de previsÃ£o em string
 * @param {Previsibilidade} previsibilidade - Dados de previsibilidade
 * @returns {Object} Objeto com main (data formatada) e subtitle (tempo restante + km restantes)
 */
export const formatDateAndRemaining = (previsaoDateString, previsibilidade = null) => {
    if (!previsaoDateString) {
        return { main: 'N/A', subtitle: '' };
    }
    const previsaoDate = new Date(previsaoDateString);
    if (isNaN(previsaoDate.getTime())) {
        return { main: 'Data invÃ¡lida', subtitle: '' };
    }
    const displayDate = previsaoDate.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
    const now = new Date();
    const diffMs = previsaoDate.getTime() - now.getTime();
    let remainingTimeText;
    if (diffMs < 0) {
        remainingTimeText = "";
    }
    else {
        let remainingSeconds = Math.floor(diffMs / 1000);
        const days = Math.floor(remainingSeconds / (3600 * 24));
        remainingSeconds -= days * 3600 * 24;
        const hours = Math.floor(remainingSeconds / 3600);
        remainingSeconds -= hours * 3600;
        const minutes = Math.floor(remainingSeconds / 60);
        let parts = [];
        if (days > 0)
            parts.push(`${days}d`);
        if (hours > 0)
            parts.push(`${hours}h`);
        if (minutes > 0 || (days === 0 && hours === 0))
            parts.push(`${minutes}m`);
        remainingTimeText = parts.length > 0 ? `(Restante: ${parts.join(' ')})` : "(Agora)";
    }
    // Adiciona informaÃ§Ãµes de quilÃ´metros restantes se disponÃ­vel
    let subtitleParts = [];
    if (remainingTimeText) {
        subtitleParts.push(remainingTimeText);
    }
    if (previsibilidade && typeof previsibilidade.kmRestante === 'number') {
        subtitleParts.push(`${previsibilidade.kmRestante} km restantes`);
    }
    const subtitle = subtitleParts.join(' â€¢ ');
    return { main: displayDate, subtitle: subtitle };
};
/**
 * Verifica se a previsÃ£o estÃ¡ atrasada
 * @param {string} previsaoDateString - Data de previsÃ£o em string
 * @returns {Object} Objeto com label, color e size para o chip de status
 */
export const verificaAtrasoPrevisao = (previsaoDateString) => {
    if (!previsaoDateString) {
        return {
            label: "Erro",
            color: "error",
            size: "large"
        };
    }
    const previsaoDate = new Date(previsaoDateString);
    if (isNaN(previsaoDate.getTime())) {
        return {
            label: "Erro",
            color: "error",
            size: "large"
        };
    }
    const now = new Date();
    const diffMs = previsaoDate.getTime() - now.getTime();
    if (diffMs < 0) {
        return {
            label: "Atrasado",
            color: "warning",
            size: "large"
        };
    }
    return {
        label: "No horÃ¡rio",
        color: "success",
        size: "large"
    };
};
